import { render, staticRenderFns } from "./CustomerBeneficiaries.vue?vue&type=template&id=01522832&scoped=true"
import script from "./CustomerBeneficiaries.vue?vue&type=script&lang=ts"
export * from "./CustomerBeneficiaries.vue?vue&type=script&lang=ts"
import style0 from "./CustomerBeneficiaries.vue?vue&type=style&index=0&id=01522832&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01522832",
  null
  
)

export default component.exports